var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlazingFast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 185,
    viewBox: "0 0 185 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.5 185C143.586 185 185 143.586 185 92.5C185 41.4137 143.586 0 92.5 0C41.4137 0 0 41.4137 0 92.5C0 143.586 41.4137 185 92.5 185Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.232 94.0239L105.443 59.6905C104.89 59.3002 104.172 59.2532 103.57 59.564C102.972 59.873 102.596 60.4929 102.596 61.1669V93.2902L54.8461 59.7104C54.2949 59.3255 53.5757 59.2749 52.974 59.5857C52.3759 59.8965 52 60.5163 52 61.1904V129.812C52 130.486 52.3759 131.106 52.974 131.416C53.2378 131.55 53.5233 131.617 53.807 131.617C54.172 131.617 54.5352 131.505 54.8461 131.288L102.596 97.7102V129.834C102.596 130.508 102.972 131.127 103.57 131.438C103.834 131.574 104.12 131.641 104.404 131.641C104.769 131.641 105.134 131.529 105.443 131.31L154.232 96.9765C154.714 96.6404 155 96.0875 155 95.5002C155 94.9129 154.714 94.36 154.232 94.0239Z",
    fill: "#DD6F69"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlazingFast);
export default __webpack_public_path__ + "static/media/Blazing-fast.17d3b7710e9d009570e8bdbdd139cc1d.svg";
export { ForwardRef as ReactComponent };